import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InvitePopUpManager from '../InvitePopUpManager';
import * as Translations from '../../providers/i18n';
import './style.scss';

const CommentsEmptyState = ({ collaboratorTab = false, placeholderTabClicked, i18n }) => {
    const iconClasses = classNames('icn-no-comments', { 'collaborator-tab': collaboratorTab, invite: placeholderTabClicked });

    if (placeholderTabClicked) {
        return (
            <div className="no-comments-wrapper">
                <div className="no-comments-text">
                    <i className={iconClasses}/>
                    <p className="font-accent">
                        {i18n.t('attachments_preview.collaboration.comments.invite_default_tab')}
                    </p>
                    <div className="invite-btn-container">
                        <InvitePopUpManager onlyCurrentFile={true} withoutDefaultTriggerMobileWevBehavior={true}/>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="no-comments-wrapper">
            <div className="no-comments-text">
                <i className={iconClasses}/>
                <p className="font-accent">
                    {collaboratorTab ? i18n.t('attachments_preview.collaboration.comments.no_comments_text_external') : i18n.t('attachments_preview.collaboration.comments.no_comments_text')}
                </p>
            </div>
        </div>
    );
};

CommentsEmptyState.propTypes = {
    collaboratorTab: PropTypes.bool,
    placeholderTabClicked: PropTypes.bool,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(CommentsEmptyState);
